/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Ground_Item_ProjectsInputs */

const en_auth_ground_item_projects = /** @type {(inputs: Auth_Ground_Item_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projects and tasks`)
};

/** @type {(inputs: Auth_Ground_Item_ProjectsInputs) => LocalizedString} */
const ar_auth_ground_item_projects = en_auth_ground_item_projects;

/** @type {(inputs: Auth_Ground_Item_ProjectsInputs) => LocalizedString} */
const he_auth_ground_item_projects = en_auth_ground_item_projects;

/** @type {(inputs: Auth_Ground_Item_ProjectsInputs) => LocalizedString} */
const ur_auth_ground_item_projects = en_auth_ground_item_projects;

/** @type {(inputs: Auth_Ground_Item_ProjectsInputs) => LocalizedString} */
const es_auth_ground_item_projects = en_auth_ground_item_projects;

/** @type {(inputs: Auth_Ground_Item_ProjectsInputs) => LocalizedString} */
const fr_auth_ground_item_projects = en_auth_ground_item_projects;

/** @type {(inputs: Auth_Ground_Item_ProjectsInputs) => LocalizedString} */
const de_auth_ground_item_projects = en_auth_ground_item_projects;

/** @type {(inputs: Auth_Ground_Item_ProjectsInputs) => LocalizedString} */
const pt_auth_ground_item_projects = en_auth_ground_item_projects;

/** @type {(inputs: Auth_Ground_Item_ProjectsInputs) => LocalizedString} */
const hi_auth_ground_item_projects = en_auth_ground_item_projects;

/** @type {(inputs: Auth_Ground_Item_ProjectsInputs) => LocalizedString} */
const bn_auth_ground_item_projects = en_auth_ground_item_projects;

/**
* | output |
* | --- |
* | "Projects and tasks" |
*
* @param {Auth_Ground_Item_ProjectsInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const auth_ground_item_projects = /** @type {((inputs?: Auth_Ground_Item_ProjectsInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Ground_Item_ProjectsInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_auth_ground_item_projects(inputs)
	if (locale === "he") return he_auth_ground_item_projects(inputs)
	if (locale === "ur") return ur_auth_ground_item_projects(inputs)
	if (locale === "es") return es_auth_ground_item_projects(inputs)
	if (locale === "fr") return fr_auth_ground_item_projects(inputs)
	if (locale === "de") return de_auth_ground_item_projects(inputs)
	if (locale === "pt") return pt_auth_ground_item_projects(inputs)
	if (locale === "hi") return hi_auth_ground_item_projects(inputs)
	if (locale === "bn") return bn_auth_ground_item_projects(inputs)
	return /** @type {LocalizedString} */ ("Projects and tasks")
});